import { Toro } from "../common/enumerations";

export class ToroControllerPreferencesModel
{
    BackLightOn: boolean;
    BeginWeek: number;
    ConcurrentStations: number;
    DateFormat: number;
    Language: number;
    LcdContrast: number;
    LengthUnit: number;
    Region: number;
    SoundOn: boolean;
    TempUnit: number;
    TimeFormat: number;
    VolumeUnit: number;

    // Rain Dial Family - Begin
    Units: number;
    ProgramStackOverlap: number;
    // Rain Dial Family - End


    //LxcSettings
    LxcSpecific?: {
        LxcLengthUnit: number;
        MasterValvePump1: Toro.MasterValvePumpSetting;
        MasterValvePump2: Toro.MasterValvePumpSetting
        PastMidnight?: number;
        RainSensorBypass1: Toro.RainSensorBypass;
        RainSensorBypass2: Toro.RainSensorBypass;
    }

    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    get is24HourTimeFormat(): boolean
    {
        return this.TimeFormat === 1;
    }

}
